import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { EmptyCartItemComponent } from '../empty-cart-item.component';

// @dynamic
@Component({
    selector: 'checkout-empty-cart-item-horizontal',
    templateUrl: './empty-cart-item-horizontal.component.html',
    standalone: true,
    imports: [NgClass],
})
export class EmptyCartItemHorizontalComponent extends EmptyCartItemComponent implements OnInit {}
